export default "__VITE_ASSET__8766d8c0__"